import React, { useState } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { NotificationManager } from "react-notifications";

import { required, max64 } from "../../../../constants/formValidators";
import { timeAndServeList } from "../../../../constants/recipeConstants";
import { submitUserRecipe } from "../../../../store/actions";
import DropZone from "../../../../sharedComponents/dropZoneWrap";
import { FormField } from "../../../../sharedComponents/formField";

const UserAddRecipe = ({ handleSubmit, submitUserRecipe, history }) => {
	const [dropZoneFiles, updateDropZoneFiles] = useState([]);

	const notify = (msg) => {
		switch (msg.type) {
			case "error":
				return NotificationManager.error(msg.text, "", 5000);
			case "success":
				return NotificationManager.success(msg.text, "", 5000);
			default:
			// do nothing
		}
	};

	const validateForm = (values) => {
		let file = null;
		if (dropZoneFiles.length) {
			file = dropZoneFiles[0].file;
		}
		const formData = new FormData();
		formData.append("name", values.name);
		formData.append("preptime", values.preptime);
		formData.append("cooktime", values.cooktime);
		formData.append("yields", values.yields);
		formData.append("serving_size", values.serving_size);
		formData.append("ingredients", values.raw_ingredients);
		formData.append("directions", values.directions);
		formData.append("notes", values.notes);
		formData.append("image", file, file.name);
		const successHandler = (event) => {
			if (event.status >= 200 && event.status < 300) {
				NotificationManager.success("Recipe Submitted", "", 5000);
				history.push(`/nutrition/recipes`);
			} else {
				NotificationManager.error("Please try again!", "", 5000);
			}
		};

		const errorHandler = (event) => {
			event && event.error_code === "VALIDATION_ERROR" && NotificationManager.error("Inavlid Fields", "", 5000);
		};

		submitUserRecipe(formData, successHandler, errorHandler);
	};

	return (
		<section className="page page-add-recipe">
			<div className="container">
				<h3 className="m-0 mb-3">Add Recipe</h3>
				<div className=" card card-primary border-0 mt-2 p-4">
					<form onSubmit={handleSubmit(validateForm)}>
						<div className="row">
							<div className="col-8">
								<div className="row">
									<Field
										label="Name"
										name="name"
										type="text"
										validate={[required, max64]}
										formGroupClass="col-9"
										component={FormField}
									/>
								</div>
								<div className="row">
									{timeAndServeList.map((input, index) => {
										return (
											<Field
												key={index}
												formGroupClass="col-3"
												component={FormField}
												{...input}
												// onChange={enable}
												min="0"
											/>
										);
									})}
								</div>
								<div className="row">
									<Field
										label="Ingredients"
										name="raw_ingredients"
										type="textarea"
										validate={[required]}
										formGroupClass="col-12"
										component={FormField}
									/>
									<Field
										label="Directions"
										name="directions"
										type="textarea"
										validate={[required]}
										formGroupClass="col-12"
										component={FormField}
									/>
									<Field
										label="Notes"
										name="notes"
										type="textarea"
										formGroupClass="col-12"
										component={FormField}
									/>
								</div>
							</div>
							<div className="d-flex justify-content-center col-4">
								<DropZone
									alert={notify}
									accepts={["jpeg", "jpg", "png", "gif", "bmp"]}
									onAdd={(files) => {
										updateDropZoneFiles(files);
									}}
									forceReset={null}
									className="w-100"
								/>
							</div>
						</div>

						<div className="row mt-2">
							<div className="col-12 text-right">
								<button type="submit" className="btn btn-primary text-uppercase">
									Submit
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</section>
	);
};

const mapDispatchToProps = { submitUserRecipe };

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm({
		form: "UserAddRecipe",
		enableReinitialize: true
	})(UserAddRecipe)
);
